import React from "react";
import Layout from "../components/base/Layout";
import SEO from "../components/base/SEO";
import PrivacyIndex from "../components/pages/privacy/Index";

const PrivacyPage = () => (
  <Layout>
    <SEO
      title="Privacy Policy - The best free receipt maker on the web"
      desc="Checkout our site's privacy policy before start using it"
      pathname="privacy-policy/"
    />
    <PrivacyIndex />
  </Layout>
);

export default PrivacyPage;
